import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { AdminAppData } from "../models/adminAppData";

export default class AppDataStore {
  loginAppData: AdminAppData | null = null;
  adminAppData: AdminAppData | null = null;

  userPermissionRegistry = new Map<string, string>();

  loginAppDataLoading = false;
  adminAppDataLoading = false;
  adminPartnerKobhovedLoading = false;
  constructor() {
    makeAutoObservable(this);
  }

  resetAppDataStore = () => {
    this.loginAppData = null;
    this.adminAppData = null;
  }

  loadLoginData = async () => {
    this.loginAppDataLoading = true;
    try {
      if (!this.loginAppData) {
        const response = await agent.AppData.getLoginRequiredData();
        runInAction(() => (this.loginAppData = response));
      }
      runInAction(() => (this.loginAppDataLoading = false));
    } catch (error) {
      console.log(error);
      runInAction(() => (this.loginAppDataLoading = false));
    }
  };

  loadAdminAppData = async () => {
    this.adminAppDataLoading = true;
    try {
      if (!this.adminAppData) {
        const response = await agent.AppData.getAdminAppData();
        runInAction(() => {
          this.adminAppData = response;
          response.userPermissions.forEach(element => {
            this.userPermissionRegistry.set(element.type, element.type);
          });
        }
        );
      }
      runInAction(() => (this.adminAppDataLoading = false));
    } catch (error) {
      console.log(error);
      runInAction(() => (this.adminAppDataLoading = false));
    }
  };
  // loadAdminPartnerKobhoved = async () => {
  //   this.adminPartnerKobhovedLoading = true;
  //   try {
  //     if (!this.adminPartnerKobhoved) {
  //       const response = await agent.AppData.getAdminPartnerKobhoved();
  //       runInAction(() => {
  //         this.adminPartnerKobhoved = response;
  //       }
  //       );
  //     }
  //     runInAction(() => (this.adminPartnerKobhovedLoading = false));
  //   } catch (error) {
  //     console.log(error);
  //     runInAction(() => (this.adminPartnerKobhovedLoading = false));
  //   }
  // };
  get userPermissions() {
    return Array.from(this.userPermissionRegistry.values());
  }
}
